import React, { createContext, useContext, useEffect, useState } from 'react';

export type Language = 'en' | 'hi';

type LanguageContextValue = {
  language: Language;
  setLanguage: (language: Language) => void;
};

const LanguageContext = createContext<LanguageContextValue | null>(null);

export const getSavedLanguage = (): Language | null => {
  const saved = localStorage.getItem('rightoz-language');
  return saved === 'en' || saved === 'hi' ? saved : null;
};

export const LanguageProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [language, setLanguageState] = useState<Language>(() => getSavedLanguage() ?? 'en');

  const setLanguage = (nextLanguage: Language) => {
    localStorage.setItem('rightoz-language', nextLanguage);
    setLanguageState(nextLanguage);
  };

  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used inside LanguageProvider');
  return context;
};
